import { ExtranetSyncEndpoint } from './endpoint'
import { HttpMethods } from '../../apiService/baseEndpoint'
import { ISyncParams } from './syncParams'

export const extranetSyncRequest = async (payload: ISyncParams) => {
  const endpoint = new ExtranetSyncEndpoint<undefined, ISyncParams>('', HttpMethods.POST, undefined, payload)
  return endpoint.execute()
}
